export default {
  dataCms: state => field => state[field]
};
